import { EVENT_SOURCE } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type InlineMessageBannerDismissedAnalyticsProps = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
};
export const onInlineMessageBannerDismissed = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: InlineMessageBannerDismissedAnalyticsProps): FireAnalyticsEvent => ({
	source: EVENT_SOURCE,
	eventType: 'ui',
	action: 'dismissed',
	actionSubject: 'inlineMessageBanner',
	attributes: {
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
